// Registro de guías prácticas (sección /guias, desde 2026-10-31; sustituye a los estudios
// automáticos). Fuente única para la landing (/guias), el router (/guias/:slug), la portada y
// el sitemap. APPEND-ONLY, como src/temas/registry.js. Una sola convención de slug: con guiones.
//
//   id/slug   nombre en la URL (/guias/<slug>) y del dataset (public/data/guias/<slug>.json)
//   numero    orden de publicación (01, 02…)
//   titulo, subtitulo, etiqueta, en: {…}   textos de la tarjeta (en inglés en `en`)
//   offline   true si se exporta como HTML autocontenido (scripts/exportar-guias.mjs).
//             La guía de la CIA, NUNCA: no debe circular por Zapya ni en el Paquete.
//   publicado YYYY-MM-DD
//   load      import dinámico del Renderer congelado

const guias = [
  {
    id: "solar-12v",
    slug: "solar-12v",
    numero: 1,
    titulo: "Conectar un sistema solar sin quemar nada",
    subtitulo: "Panel, controlador, batería e inversor de 12 V, en el orden correcto, con una calculadora para saber qué comprar",
    etiqueta: "Energía",
    en: {
      titulo: "Wiring a solar kit without burning anything",
      subtitulo: "Panel, charge controller, battery and 12 V inverter, in the right order, with a calculator to size what to buy",
      etiqueta: "Energy",
    },
    offline: true,
    publicado: "2026-10-31",
    load: () => import("./solar-12v/Renderer.jsx"),
  },
  {
    id: "contacto-seguro-cia",
    slug: "contacto-seguro-cia",
    numero: 2,
    titulo: "Contactar con la CIA sin exponerte",
    subtitulo: "Qué pidió la CIA a los cubanos en octubre de 2026, con la fuente de cada línea, y qué ve cada actor de la red",
    etiqueta: "Seguridad digital",
    en: {
      titulo: "Contacting the CIA without exposing yourself",
      subtitulo: "What the CIA asked of Cubans in October 2026, with the source for every line, and what each party on the network can see",
      etiqueta: "Digital security",
    },
    offline: false,
    publicado: "2026-10-31",
    load: () => import("./contacto-seguro-cia/Renderer.jsx"),
  },
  {
    id: "biogas",
    slug: "biogas",
    numero: 3,
    titulo: "Cocina de gas con la basura de la casa",
    subtitulo: "Un biodigestor de dos tanques convierte los restos de cocina en biogás para el fogón y en abono líquido",
    etiqueta: "Energía y comida",
    en: {
      titulo: "Cooking gas from household waste",
      subtitulo: "A two-tank digester turns kitchen waste into biogas for the stove and liquid fertiliser for the garden",
      etiqueta: "Energy and food",
    },
    offline: true,
    publicado: "2026-10-31",
    load: () => import("./biogas/Renderer.jsx"),
  },
];

export default guias;
